import React from 'react';
import { motion } from 'framer-motion';
import { Shield, UserCheck, ThumbsUp, Phone } from 'lucide-react';
export function Trust() {
  const badges = [{
    icon: <UserCheck size={24} data-id="element-158" />,
    text: 'Atención profesional'
  }, {
    icon: <Shield size={24} data-id="element-159" />,
    text: 'Evaluación según caso'
  }, {
    icon: <ThumbsUp size={24} data-id="element-160" />,
    text: 'Explicación clara'
  }, {
    icon: <Phone size={24} data-id="element-161" />,
    text: 'WhatsApp directo'
  }];
  return <section className="bg-white py-20 lg:py-28" data-id="element-162">
      <div className="container mx-auto px-4 md:px-6" data-id="element-163">
        <div className="mx-auto max-w-4xl rounded-3xl bg-brand-dark p-8 md:p-12 lg:p-16 shadow-2xl relative overflow-hidden" data-id="element-164">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 -mr-20 -mt-20 h-64 w-64 rounded-full bg-white/5 blur-3xl" data-id="element-165"></div>
          <div className="absolute bottom-0 left-0 -ml-20 -mb-20 h-64 w-64 rounded-full bg-brand-accent/10 blur-3xl" data-id="element-166"></div>

          <div className="relative z-10 text-center" data-id="element-167">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="mb-6 text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-168">
              Tu salud dental merece una atención clara
            </motion.h2>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="mx-auto mb-12 max-w-2xl text-lg text-slate-300" data-id="element-169">
              Cada caso debe revisarse con criterio profesional. Por eso, esta
              consulta busca orientar al paciente de forma clara, explicar las
              opciones disponibles y evitar pasos innecesarios cuando no aportan
              a la solución.
            </motion.p>

            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4" data-id="element-170">
              {badges.map((badge, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + index * 0.1
            }} className="flex flex-col items-center justify-center gap-3 rounded-xl bg-white/10 p-4 backdrop-blur-sm border border-white/10" data-id="element-171">
                  <div className="text-brand-accent" data-id="element-172">{badge.icon}</div>
                  <span className="text-sm font-medium text-white text-center" data-id="element-173">
                    {badge.text}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}